import React from "react";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

const GenerarPdf = () => {

    const ReporteStock = (data, razonSocial, domicilio, cuit, listaPrecio) => {

        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "portrait",
            pageMargins: [20, 20, 20, 20],

            content: [
                {
                    columns: [
                        {
                            width: "40%",
                            table: {
                                widths: [60, "*"],
                                body: [
                                    [
                                        { text: "Razón social:", bold: true, fontSize: 10 },
                                        { text: razonSocial, fontSize: 10 }
                                    ],
                                    [
                                        { text: "Domicilio:", bold: true, fontSize: 10 },
                                        { text: domicilio, fontSize: 10 }
                                    ],
                                    [
                                        { text: "C.U.I.T.:", bold: true, fontSize: 10 },
                                        { text: cuit, fontSize: 10 }
                                    ]
                                ]
                            },
                            layout: "noBorders"
                        },
                        {
                            width: "20%",
                            text: "",
                            fontSize: 1,
                            bold: true,
                            margin: [0, 0, 0, 0]
                        },
                        {
                            width: "40%",
                            table: {
                                widths: [100, "*"],
                                body: [
                                    [
                                        { text: "Lista de Precios:", bold: true, fontSize: 10, alignment: "right" },
                                        { text: listaPrecio, fontSize: 10, alignment: "right" }
                                    ]
                                ]
                            },
                            layout: "noBorders",
                        }
                    ]
                },
                {
                    width: "100%",
                    text: "Reporte General de Stock",
                    fontSize: 16,
                    bold: true,
                    margin: [0, 10, 0, 0], // mejor alineación en vertical
                    alignment: "center"
                },

                { text: "\n" },

                {
                    table: {
                        widths: [67, "*", 55, 55, 55, 55],
                        body: [
                            [
                                { text: "CÓDIGO", bold: true, fontSize: 10 },
                                { text: "NOMBRE", bold: true, fontSize: 10 },
                                { text: "RUBRO", bold: true, fontSize: 10 },
                                { text: "FAMILIA", bold: true, fontSize: 10 },
                                { text: "CANTIDAD", bold: true, fontSize: 10 },
                                { text: "PRECIO", bold: true, alignment: "right", fontSize: 10 }
                            ],
                            ...data.map(item => [
                                { text: item.sku, fontSize: 9 },
                                { text: item.nombre, fontSize: 9 },
                                { text: item.proveedor, fontSize: 9 },
                                { text: item.familia, fontSize: 9 },
                                { text: item.cantidad, alignment: "left", fontSize: 9 },
                                { text: item.precio, alignment: "right", fontSize: 9 }
                            ])
                        ]
                    },
                    layout: "noBorders"
                    // layout: "lightHorizontalLines" 
                }
            ]
        };

        pdfMake.createPdf(docDefinition).open();
    };

    const ReporteTransacciones = (data, razonSocial, domicilio, cuit) => {
        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "landscape",
            pageMargins: [20, 20, 20, 20],

            content: [
                {
                    columns: [
                        {
                            width: "40%",
                            table: {
                                widths: [60, "*"],
                                body: [
                                    [
                                        { text: "Razón social:", bold: true, fontSize: 10 },
                                        { text: razonSocial, fontSize: 10 }
                                    ],
                                    [
                                        { text: "Domicilio:", bold: true, fontSize: 10 },
                                        { text: domicilio, fontSize: 10 }
                                    ],
                                    [
                                        { text: "C.U.I.T.:", bold: true, fontSize: 10 },
                                        { text: cuit, fontSize: 10 }
                                    ]
                                ]
                            },
                            layout: "noBorders"
                        },
                        {
                            width: "20%",
                            text: "",
                            fontSize: 1,
                            bold: true,
                            margin: [0, 0, 0, 0]
                        },
                        {
                            width: "40%",
                            table: {
                                widths: ["*"],
                                body: [
                                    [
                                        { text: "Aplica solo a turno en curso", bold: true, fontSize: 10, alignment: "right" }
                                    ]
                                ]
                            },
                            layout: "noBorders",
                        }
                    ]
                },
                {
                    width: "100%",
                    text: "Total de ventas por producto",
                    fontSize: 16,
                    bold: true,
                    margin: [0, 10, 0, 0], // mejor alineación en vertical
                    alignment: "center"
                },

                { text: "\n" },

                {
                    table: {
                        widths: [40, 150, "*", 100, 100, 70, 70],
                        body: [
                            [
                                { text: "N° OP", bold: true, fontSize: 10 },
                                { text: "CÓDIGO", bold: true, fontSize: 10 },
                                { text: "NOMBRE", bold: true, fontSize: 10 },
                                { text: "TIPO", bold: true, fontSize: 10 },
                                { text: "EMPLEADO", bold: true, fontSize: 10 },
                                { text: "SUBTOTAL", bold: true, fontSize: 10 },
                                { text: "TOTAL", bold: true, alignment: "right", fontSize: 10 }
                            ],
                            ...data.map(transaccion => {
                                const productos = transaccion.productos;
                                return productos.map(producto => [
                                    { text: transaccion.id.toString(), fontSize: 10 },
                                    { text: producto.codigo, fontSize: 10 },
                                    { text: producto.descripcion, fontSize: 10 },
                                    { text: transaccion.tipoticket, fontSize: 10 },
                                    { text: transaccion.empleado, fontSize: 10 },
                                    { text: `$${producto.total.toFixed(2)}`, fontSize: 10 },
                                    { text: transaccion.total, fontSize: 10, alignment: "right" }
                                ]);
                            }).flat()
                        ]
                    },
                    layout: "noBorders"
                    // layout: "lightHorizontalLines" 
                }
            ]
        };

        pdfMake.createPdf(docDefinition).open();
    };


    const ReporteCierreIndividual = (data, razonSocial, domicilio, cuit, empleado, nombreEstacion, modulo, sector, fechaCierre) => {

        const parseJsonSafe = (str) => {
            if (!str) return [];
            if (typeof str === 'object') return str;
            try {
                return JSON.parse(str);
            } catch (e) {
                console.error("Error parsing JSON:", e);
                return [];
            }
        };

        const aforadoresAuto = parseJsonSafe(data.aforadoresauto);
        const aforadoresManual = parseJsonSafe(data.aforadoresmanual);
        const todosAforadores = [...(Array.isArray(aforadoresAuto) ? aforadoresAuto : []), ...(Array.isArray(aforadoresManual) ? aforadoresManual : [])];

        const modificaciones = parseJsonSafe(data.modificaciones);
        const modificacionesArray = Array.isArray(modificaciones) ? modificaciones : [];
        const ultimoCambio = modificacionesArray.length > 0 ? modificacionesArray[modificacionesArray.length - 1] : null;
        const cambios = ultimoCambio ? ultimoCambio.cambios : {};

        const isFieldChanged = (field) => cambios.hasOwnProperty(field);

        const getPreviousAforador = (item, type) => {
            if (!cambios[type]) return null;
            const anterior = cambios[type].anterior || [];
            return anterior.find(p => p.manguera == item.manguera && p.tipocombustible == item.tipocombustible);
        };

        const isAforadorValueChanged = (item, field, type) => {
            if (!cambios[type]) return false;
            const prev = getPreviousAforador(item, type);
            if (!prev) return false;
            return item[field] != prev[field];
        };

        const tiradasDetalle = data.tiradas_detalle || [];
        const title = `${nombreEstacion}_${modulo}_${sector}_${new Date(fechaCierre).toISOString().split('T')[0]}`;

        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "landscape",
            pageMargins: [20, 20, 20, 20],
            info: {
                title: title,
                author: 'SisGes',
                subject: 'Reporte de Cierre de Turno Individual',
                keywords: 'reporte, cierre, turno, individual',
            },

            content: [
                {
                    columns: [
                        {
                            width: "50%",
                            margin: [10, 10, 0, 0],
                            table: {
                                widths: [70, "*"],
                                body: [
                                    [{ text: "Razón social:", bold: true, fontSize: 10 }, { text: razonSocial, fontSize: 10 }],
                                    [{ text: "Domicilio:", bold: true, fontSize: 10 }, { text: domicilio, fontSize: 10 }],
                                    [{ text: "C.U.I.T.:", bold: true, fontSize: 10 }, { text: cuit, fontSize: 10 }],
                                    [{ text: "Empleado:", bold: true, fontSize: 10 }, { text: empleado, fontSize: 10 }]
                                ]
                            },
                            layout: "noBorders"
                        },
                        {
                            width: "50%",
                            margin: [0, 10, 10, 0],
                            table: {
                                widths: [160, "*"],
                                body: [
                                    [{ text: "Desde:", bold: true, fontSize: 10, alignment: "right" }, { text: new Date(data.fechainicio).toLocaleString(), fontSize: 10, alignment: "left" }],
                                    [{ text: "Hasta:", bold: true, fontSize: 10, alignment: "right" }, { text: new Date(data.fechafin).toLocaleString(), fontSize: 10, alignment: "left" }],
                                    [{ text: "Deposito:", bold: true, fontSize: 10, alignment: "right" }, { text: `${nombreEstacion} - ${modulo} ${sector}`, fontSize: 10, alignment: "left" }],
                                    [{ text: "Cierre N°:", bold: true, fontSize: 10, alignment: "right" }, { text: `${data.num} - ID: ${data.id}`, fontSize: 10, alignment: "left" }]
                                ]
                            },
                            layout: "noBorders"
                        }
                    ]
                },
                { text: "\n" },
                { text: "Reporte de Cierre de Turno", fontSize: 16, bold: true, alignment: "center" },
                { text: "\n" },
                { text: "ESTADO DE AFORADORES", fontSize: 12, bold: true, margin: [0, 5, 0, 5], alignment: "center" },
                {
                    table: {
                        headerRows: 2,
                        widths: ["*", "*", "*", "*", "*", "*", "*", "*", "*"],
                        body: [
                            [
                                { text: "NRO.", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "PRODUCTO", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "PRECIO $", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "LTS. INICIO", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "LTS.", bold: true, fontSize: 9, colSpan: 2, alignment: 'center' },
                                {},
                                { text: "LTS. FINAL", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "LTS. DIF", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "DIFERENCIA", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] }
                            ],
                            [
                                {}, {}, {}, {},
                                { text: "PRUEBA RET.", bold: true, fontSize: 8, alignment: 'center' },
                                { text: "PRUEBA S/RET.", bold: true, fontSize: 8, alignment: 'center' },
                                {}, {}, {}
                            ],
                            ...todosAforadores.map(item => {
                                const precios = parseJsonSafe(data.precios);
                                const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                const precio = precioObj ? precioObj.precio : 0;
                                const isGNC = item.tipocombustible === 'GNC';
                                const corrida = parseFloat(item.corrida || 0);
                                const litDif = (item.final - item.inicial) - corrida;
                                const isAuto = aforadoresAuto.some(p => p.manguera == item.manguera && p.tipocombustible == item.tipocombustible);
                                const type = isAuto ? 'aforadoresauto' : 'aforadoresmanual';

                                return [
                                    { text: item.manguera, fontSize: 9 },
                                    { text: item.tipocombustible, fontSize: 9 },
                                    { text: `$ ${parseFloat(precio).toLocaleString('es-AR', { minimumFractionDigits: 3 })}`, fontSize: 9, alignment: 'right' },
                                    { text: parseFloat(item.inicial).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', color: isAforadorValueChanged(item, 'inicial', type) ? 'red' : 'black' },
                                    { text: parseFloat(isGNC ? 0 : corrida).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', color: !isGNC && isAforadorValueChanged(item, 'corrida', type) ? 'red' : 'black' },
                                    { text: parseFloat(isGNC ? corrida : 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', color: isGNC && isAforadorValueChanged(item, 'corrida', type) ? 'red' : 'black' },
                                    { text: parseFloat(item.final).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', color: isAforadorValueChanged(item, 'final', type) ? 'red' : 'black' },
                                    { text: litDif.toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right' },
                                    { text: `$ ${(litDif * precio).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' }
                                ];
                            }),
                            // Total Row
                            [
                                { text: "TOTALES", bold: true, fontSize: 9, colSpan: 4, alignment: 'right' },
                                {}, {}, {},
                                {
                                    text: todosAforadores.reduce((acc, item) => {
                                        const isGNC = item.tipocombustible === 'GNC';
                                        return acc + (isGNC ? 0 : parseFloat(item.corrida || 0));
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true
                                },
                                {
                                    text: todosAforadores.reduce((acc, item) => {
                                        const isGNC = item.tipocombustible === 'GNC';
                                        return acc + (isGNC ? parseFloat(item.corrida || 0) : 0);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true
                                },
                                { text: todosAforadores.reduce((acc, item) => acc + parseFloat(item.final || 0), 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true },
                                {
                                    text: todosAforadores.reduce((acc, item) => {
                                        const diferencia = item.final - item.inicial;
                                        const corrida = parseFloat(item.corrida || 0);
                                        return acc + (diferencia - corrida);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true
                                },
                                {
                                    text: `$ ${todosAforadores.reduce((acc, item) => {
                                        const diferencia = item.final - item.inicial;
                                        const precios = parseJsonSafe(data.precios);
                                        const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                        const precio = precioObj ? precioObj.precio : 0;
                                        const corrida = parseFloat(item.corrida || 0);
                                        return acc + ((diferencia - corrida) * precio);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right', bold: true
                                }
                            ]
                        ]
                    },
                    layout: "lightHorizontalLines"
                },
                { text: "\n" },
                {
                    width: "100%",
                    text: "VENTAS POR PRODUCTO",
                    fontSize: 12,
                    bold: true,
                    margin: [0, 5, 0, 5],
                    alignment: "center"
                },
                {
                    table: {
                        headerRows: 1,
                        widths: ["*", "*", "*", "*", "*", "*", "*"],
                        body: [
                            [
                                { text: "COMBUSTIBLE", bold: true, fontSize: 9 },
                                { text: "LTS. VENTA", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "IMP. VENTA", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "LTS. FACT.", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "IMP. FACT.", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "LTS. DIF.", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "PESOS DIF.", bold: true, fontSize: 9, alignment: 'right' }
                            ],
                            ...Object.values(todosAforadores.reduce((acc, item) => {
                                const combustible = item.tipocombustible;
                                if (!acc[combustible]) {
                                    acc[combustible] = {
                                        nombre: combustible,
                                        ltsVenta: 0,
                                        impVenta: 0,
                                        ltsFact: 0,
                                        impFact: 0
                                    };
                                }
                                const diferencia = item.final - item.inicial;
                                const precios = parseJsonSafe(data.precios);
                                const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                const precio = precioObj ? precioObj.precio : 0;
                                const corrida = parseFloat(item.corrida || 0);
                                const litrosDif = diferencia - corrida;
                                const diferenciaPesos = litrosDif * precio;

                                acc[combustible].ltsVenta += litrosDif;
                                acc[combustible].impVenta += diferenciaPesos;
                                return acc;
                            }, {})).map(prod => {
                                const ltsDif = prod.ltsVenta - prod.ltsFact;
                                const pesosDif = prod.impVenta - prod.impFact;
                                return [
                                    { text: prod.nombre, fontSize: 9 },
                                    { text: prod.ltsVenta.toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right' },
                                    { text: `$ ${prod.impVenta.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' },
                                    { text: prod.ltsFact.toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right' },
                                    { text: `$ ${prod.impFact.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' },
                                    { text: ltsDif.toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right' },
                                    { text: `$ ${pesosDif.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' }
                                ];
                            }),
                            // Total Row for Sales
                            [
                                { text: "TOTALES", bold: true, fontSize: 9, alignment: 'right' },
                                {
                                    text: Object.values(todosAforadores.reduce((acc, item) => {
                                        const combustible = item.tipocombustible;
                                        if (!acc[combustible]) {
                                            acc[combustible] = { lts: 0 };
                                        }
                                        const diferencia = item.final - item.inicial;
                                        const corrida = parseFloat(item.corrida || 0);
                                        acc[combustible].lts += (diferencia - corrida);
                                        return acc;
                                    }, {})).reduce((sum, current) => sum + current.lts, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true
                                },
                                {
                                    text: `$ ${Object.values(todosAforadores.reduce((acc, item) => {
                                        const combustible = item.tipocombustible;
                                        if (!acc[combustible]) {
                                            acc[combustible] = { imp: 0 };
                                        }
                                        const diferencia = item.final - item.inicial;
                                        const precios = parseJsonSafe(data.precios);
                                        const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                        const precio = precioObj ? precioObj.precio : 0;
                                        const corrida = parseFloat(item.corrida || 0);
                                        acc[combustible].imp += ((diferencia - corrida) * precio);
                                        return acc;
                                    }, {})).reduce((sum, current) => sum + current.imp, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right', bold: true
                                },
                                { text: "0,00", fontSize: 9, alignment: 'right', bold: true },
                                { text: "$ 0,00", fontSize: 9, alignment: 'right', bold: true },
                                {
                                    text: Object.values(todosAforadores.reduce((acc, item) => {
                                        const combustible = item.tipocombustible;
                                        if (!acc[combustible]) {
                                            acc[combustible] = { lts: 0 };
                                        }
                                        const diferencia = item.final - item.inicial;
                                        const corrida = parseFloat(item.corrida || 0);
                                        acc[combustible].lts += (diferencia - corrida);
                                        return acc;
                                    }, {})).reduce((sum, current) => sum + current.lts, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true
                                },
                                {
                                    text: `$ ${Object.values(todosAforadores.reduce((acc, item) => {
                                        const combustible = item.tipocombustible;
                                        if (!acc[combustible]) {
                                            acc[combustible] = { imp: 0 };
                                        }
                                        const diferencia = item.final - item.inicial;
                                        const precios = parseJsonSafe(data.precios);
                                        const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                        const precio = precioObj ? precioObj.precio : 0;
                                        const corrida = parseFloat(item.corrida || 0);
                                        acc[combustible].imp += ((diferencia - corrida) * precio);
                                        return acc;
                                    }, {})).reduce((sum, current) => sum + current.imp, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right', bold: true
                                }
                            ]
                        ]
                    },
                    layout: "lightHorizontalLines"
                },
                { text: "\n" },
                ...(() => {
                    const combustiblesNames = parseJsonSafe(data.precios).map(p => p.nombre);
                    const transacciones = data.transacciones_detalle || [];
                    const productosVarios = [];

                    transacciones.forEach(trans => {
                        if (trans.tipoticket !== 'REMITO') {
                            const items = parseJsonSafe(trans.productos);
                            items.forEach(item => {
                                if (!combustiblesNames.includes(item.descripcion)) {
                                    const existing = productosVarios.find(pv => pv.descripcion === item.descripcion);
                                    if (existing) {
                                        existing.cantidad += parseFloat(item.cantidad || 0);
                                        existing.total += parseFloat(item.total || 0);
                                    } else {
                                        productosVarios.push({
                                            descripcion: item.descripcion,
                                            cantidad: parseFloat(item.cantidad || 0),
                                            precio: parseFloat(item.precio || 0),
                                            total: parseFloat(item.total || 0)
                                        });
                                    }
                                }
                            });
                        }
                    });

                    if (productosVarios.length === 0) return [];

                    return [
                        { text: "PRODUCTOS VARIOS", fontSize: 12, bold: true, margin: [0, 5, 0, 5], alignment: "center" },
                        {
                            table: {
                                headerRows: 1,
                                widths: ["*", "auto", "auto", "auto"],
                                body: [
                                    [
                                        { text: "DESCRIPCION", bold: true, fontSize: 9 },
                                        { text: "CANTIDAD", bold: true, fontSize: 9, alignment: 'right' },
                                        { text: "PRECIO", bold: true, fontSize: 9, alignment: 'right' },
                                        { text: "TOTAL", bold: true, fontSize: 9, alignment: 'right' }
                                    ],
                                    ...productosVarios.map(pv => [
                                        { text: pv.descripcion, fontSize: 9 },
                                        { text: pv.cantidad.toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right' },
                                        { text: `$ ${pv.precio.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' },
                                        { text: `$ ${pv.total.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' }
                                    ]),
                                    [
                                        { text: "TOTAL", bold: true, fontSize: 9, alignment: 'right' },
                                        { text: productosVarios.reduce((acc, pv) => acc + pv.cantidad, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true },
                                        {},
                                        { text: `$ ${productosVarios.reduce((acc, pv) => acc + pv.total, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right', bold: true }
                                    ]
                                ]
                            },
                            layout: "lightHorizontalLines"
                        },
                        { text: "\n" }
                    ];
                })(),
                ...(() => {
                    const transacciones = data.transacciones_detalle || [];
                    const remitos = transacciones.filter(t => t.tipoticket === 'REMITO');

                    if (remitos.length === 0) return [];

                    return [
                        { text: "REMITOS", fontSize: 12, bold: true, margin: [0, 5, 0, 5], alignment: "center" },
                        {
                            table: {
                                headerRows: 1,
                                widths: ["auto", "auto", "*", "auto"],
                                body: [
                                    [
                                        { text: "N° REMITO", bold: true, fontSize: 9 },
                                        { text: "FECHA", bold: true, fontSize: 9 },
                                        { text: "CLIENTE", bold: true, fontSize: 9 },
                                        { text: "TOTAL", bold: true, fontSize: 9, alignment: 'right' }
                                    ],
                                    ...remitos.map(r => {
                                        const subtipo = parseJsonSafe(r.subtipoticket);
                                        const client = parseJsonSafe(r.cliente);
                                        const numRemito = subtipo.pv && subtipo.numero ? `${subtipo.pv}-${subtipo.numero}` : (subtipo.numero || r.numticket || '-');
                                        const nombreCliente = client.nombre || r.cliente_nombre || r.razonsocial || '-';

                                        return [
                                            { text: numRemito, fontSize: 9 },
                                            { text: new Date(r.created_at).toLocaleString(), fontSize: 9 },
                                            { text: nombreCliente, fontSize: 9 },
                                            { text: `$ ${parseFloat(r.total || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' }
                                        ];
                                    }),
                                    [
                                        { text: "TOTAL", bold: true, fontSize: 9, colSpan: 3, alignment: 'right' },
                                        {}, {},
                                        { text: `$ ${remitos.reduce((acc, r) => acc + parseFloat(r.total || 0), 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right', bold: true }
                                    ]
                                ]
                            },
                            layout: "lightHorizontalLines"
                        },
                        { text: "\n" }
                    ];
                })(),
                ...(tiradasDetalle.length > 0 ? [
                    { text: "TIRADAS AL BUZÓN", fontSize: 12, bold: true, margin: [0, 5, 0, 5], alignment: "center" },
                    {
                        table: {
                            widths: ["auto", "*", "auto", "auto"],
                            body: [
                                [
                                    { text: "FECHA", bold: true, fontSize: 9 },
                                    { text: "EMPLEADO", bold: true, fontSize: 9 },
                                    { text: "N° TIRADA", bold: true, fontSize: 9 },
                                    { text: "MONTO", bold: true, fontSize: 9, alignment: 'right' }
                                ],
                                ...tiradasDetalle.map(t => [
                                    { text: new Date(t.created_at).toLocaleString(), fontSize: 9 },
                                    { text: t.empleado, fontSize: 9 },
                                    { text: t.numtirada, fontSize: 9 },
                                    { text: `$ ${parseFloat(t.monto).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' }
                                ])
                            ]
                        }
                    },
                    { text: "\n" }
                ] : []),
                {
                    columns: [
                        {
                            width: "50%",
                            table: {
                                widths: ["*", "auto"],
                                body: [
                                    [{ text: "RESUMEN DE CAJA", bold: true, fontSize: 10, colSpan: 2, alignment: 'center' }, {}],
                                    [{ text: "EFECTIVO:", fontSize: 9 }, { text: `$ 0.00`, fontSize: 9, alignment: "right" }],
                                    [{ text: "TARJETAS:", fontSize: 9 }, { text: `$ ${parseFloat(data.importetarjetas || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: "right", color: isFieldChanged('importetarjetas') ? 'red' : 'black' }],
                                    [{ text: "FONDO FIJO:", fontSize: 9 }, { text: `$ ${parseFloat(data.fondofijo || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: "right", color: isFieldChanged('fondofijo') ? 'red' : 'black' }],
                                    [{ text: "TIRADAS AL BUZÓN:", fontSize: 9 }, { text: `$ ${tiradasDetalle.reduce((acc, t) => acc + parseFloat(t.monto || 0), 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: "right" }]
                                ]
                            }
                        },
                        { width: "5%", text: "" },
                        {
                            width: "45%",
                            table: {
                                widths: ["*", "auto"],
                                body: [
                                    [{ text: "PROMOCIONES", bold: true, fontSize: 10, colSpan: 2, alignment: 'center' }, {}],
                                    [{ text: "PROMOCIONES:", fontSize: 9 }, { text: `$ ${parseFloat(parseJsonSafe(data.promociones)?.promociones?.monto || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: "right", color: isFieldChanged('promociones') ? 'red' : 'black' }],
                                    [{ text: "V. ANTICIPADA:", fontSize: 9 }, { text: `$ ${parseFloat(parseJsonSafe(data.promociones)?.ventaanticipada?.monto || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: "right", color: isFieldChanged('promociones') ? 'red' : 'black' }],
                                    [{ text: "BONIFICACION:", fontSize: 9 }, { text: `$ ${parseFloat(parseJsonSafe(data.promociones)?.bonificacion?.monto || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: "right", color: isFieldChanged('promociones') ? 'red' : 'black' }]
                                ]
                            }
                        }
                    ]
                },
                { text: "\n" },
                ...(modificacionesArray.length > 0 ? [
                    { text: "HISTORIAL DE MODIFICACIONES", fontSize: 12, bold: true, margin: [0, 5, 0, 5], alignment: "center" },
                    {
                        table: {
                            widths: ["auto", "auto", "auto", "*"],
                            body: [
                                [
                                    { text: "FECHA", bold: true, fontSize: 9 },
                                    { text: "USUARIO", bold: true, fontSize: 9 },
                                    { text: "MOTIVO", bold: true, fontSize: 9 },
                                    { text: "DETALLE", bold: true, fontSize: 9 }
                                ],
                                ...modificacionesArray.map(mod => {
                                    let det = [];
                                    if (mod.cambios) {
                                        Object.keys(mod.cambios).forEach(k => {
                                            const c = mod.cambios[k];
                                            if (k === 'importetarjetas') det.push(`Tarjetas: $${c.anterior} -> $${c.nuevo}`);
                                            else if (k === 'fondofijo') det.push(`Fondo: $${c.anterior} -> $${c.nuevo}`);
                                            else if (k === 'promociones') det.push(`Promos modificadas`);
                                            else if (k === 'aforadoresauto' || k === 'aforadoresmanual') {
                                                (c.nuevo || []).forEach(n => {
                                                    const a = (c.anterior || []).find(x => x.manguera == n.manguera && x.tipocombustible == n.tipocombustible);
                                                    if (a) {
                                                        if (a.inicial != n.inicial) det.push(`M${n.manguera} Ini: ${a.inicial}->${n.inicial}`);
                                                        if (a.final != n.final) det.push(`M${n.manguera} Fin: ${a.final}->${n.final}`);
                                                        if (a.corrida != n.corrida) det.push(`M${n.manguera} Corr: ${a.corrida}->${n.corrida}`);
                                                    } else {
                                                        det.push(`M${n.manguera} Nuevo`);
                                                    }
                                                });
                                            }
                                        });
                                    }
                                    return [
                                        { text: new Date(mod.fecha).toLocaleString(), fontSize: 9 },
                                        { text: mod.usuario_nombre, fontSize: 9 },
                                        { text: mod.motivo || '-', fontSize: 9 },
                                        { text: det.join('\n'), fontSize: 8 }
                                    ];
                                })
                            ]
                        }
                    }
                ] : [])
            ]
        };
        pdfMake.createPdf(docDefinition).open();
    };

    const ReporteListaCierres = (data, razonSocial, domicilio, cuit, desde, hasta, deposito, empleado) => {
        const parseJsonSafe = (str) => {
            if (!str) return [];
            if (typeof str === 'object') return str;
            try {
                return JSON.parse(str);
            } catch (e) {
                console.error("Error parsing JSON:", e);
                return [];
            }
        };

        // Check if there are multiple stations
        const stations = [...new Set(data.map(item => item.nombreEstacion))];
        const hasMultipleStations = stations.length > 1;

        // Aggregate all aforadores
        const allAforadores = data.flatMap(cierre => {
            const auto = parseJsonSafe(cierre.aforadoresauto);
            const manual = parseJsonSafe(cierre.aforadoresmanual);
            const combined = [
                ...(Array.isArray(auto) ? auto.map(af => ({ ...af, type: 'aforadoresauto' })) : []),
                ...(Array.isArray(manual) ? manual.map(af => ({ ...af, type: 'aforadoresmanual' })) : [])
            ];
            const mods = parseJsonSafe(cierre.modificaciones);
            const lastMod = Array.isArray(mods) && mods.length > 0 ? mods[mods.length - 1] : null;
            const cambios = lastMod ? lastMod.cambios : {};

            return combined.map(af => ({
                ...af,
                nombreEstacion: cierre.nombreEstacion,
                precios: cierre.precios,
                cambios: cambios
            }));
        });

        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "landscape",
            pageMargins: [20, 20, 20, 20],
            info: {
                title: 'Reporte General de Cierres',
                author: 'SisGes',
                subject: 'Reporte General de Cierres',
                keywords: 'reporte, cierre, turno, general',
            },

            content: [
                {
                    columns: [
                        {
                            width: "50%",
                            margin: [10, 10, 0, 0],
                            table: {
                                widths: [70, "*"],
                                body: [
                                    [
                                        { text: "Razón social:", bold: true, fontSize: 10 },
                                        { text: razonSocial, fontSize: 10 }
                                    ],
                                    [
                                        { text: "Domicilio:", bold: true, fontSize: 10 },
                                        { text: domicilio, fontSize: 10 }
                                    ],
                                    [
                                        { text: "C.U.I.T.:", bold: true, fontSize: 10 },
                                        { text: cuit, fontSize: 10 }
                                    ]
                                ]
                            },
                            layout: "noBorders"
                        },
                        {
                            width: "50%",
                            margin: [0, 10, 10, 0],
                            table: {
                                widths: [60, "*"],
                                body: [
                                    [
                                        { text: "Desde:", bold: true, fontSize: 10, alignment: "right" },
                                        { text: desde, fontSize: 10, alignment: "left" }
                                    ],
                                    [
                                        { text: "Hasta:", bold: true, fontSize: 10, alignment: "right" },
                                        { text: hasta, fontSize: 10, alignment: "left" }
                                    ],
                                    [
                                        { text: "Deposito:", bold: true, fontSize: 10, alignment: "right" },
                                        { text: deposito, fontSize: 10, alignment: "left" }
                                    ],
                                    [
                                        { text: "Empleado:", bold: true, fontSize: 10, alignment: "right" },
                                        { text: empleado, fontSize: 10, alignment: "left" }
                                    ]
                                ]
                            },
                            layout: "noBorders"
                        }
                    ]
                },
                { text: "\n" },
                {
                    width: "100%",
                    text: "Reporte General de Cierres",
                    fontSize: 16,
                    bold: true,
                    margin: [0, 10, 0, 0],
                    alignment: "center"
                },
                { text: "\n" },
                {
                    width: "100%",
                    text: "ESTADO DE AFORADORES",
                    fontSize: 12,
                    bold: true,
                    margin: [0, 5, 0, 5],
                    alignment: "center"
                },
                {
                    table: {
                        headerRows: 2,
                        widths: hasMultipleStations ? ["auto", "*", "*", "*", "*", "*", "*", "*", "*", "*"] : ["*", "*", "*", "*", "*", "*", "*", "*", "*"],
                        body: [
                            [
                                ...(hasMultipleStations ? [{ text: "ESTACION", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] }] : []),
                                { text: "NRO.", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "PRODUCTO", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "PRECIO $", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "LTS. INICIO", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "LTS.", bold: true, fontSize: 9, colSpan: 2, alignment: 'center' },
                                {},
                                { text: "LTS. FINAL", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "LTS. DIF", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] },
                                { text: "DIFERENCIA", bold: true, fontSize: 9, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0] }
                            ],
                            [
                                ...(hasMultipleStations ? [{}] : []),
                                {},
                                {},
                                {},
                                {},
                                { text: "PRUEBA RET.", bold: true, fontSize: 8, alignment: 'center' },
                                { text: "PRUEBA S/RET.", bold: true, fontSize: 8, alignment: 'center' },
                                {},
                                {},
                                {}
                            ],
                            ...allAforadores.map((item) => {
                                const diferencia = item.final - item.inicial;
                                const precios = parseJsonSafe(item.precios);
                                const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                const precio = precioObj ? precioObj.precio : 0;

                                const isGNC = item.tipocombustible === 'GNC';
                                const corrida = parseFloat(item.corrida || 0);
                                const pruebaRet = isGNC ? 0 : corrida;
                                const pruebaSRet = isGNC ? corrida : 0;

                                const litrosDif = diferencia - corrida;
                                const diferenciaPesos = litrosDif * precio;

                                const cambios = item.cambios || {};
                                const getPreviousAforador = (af, type) => {
                                    if (!cambios[type]) return null;
                                    const anterior = cambios[type].anterior;
                                    return anterior.find(p => p.manguera == af.manguera && p.tipocombustible == af.tipocombustible);
                                };

                                const isChanged = (field) => {
                                    const prev = getPreviousAforador(item, item.type);
                                    if (!prev) return false;
                                    return item[field] != prev[field];
                                };

                                const colorInicial = isChanged('inicial') ? 'red' : 'black';
                                const colorFinal = isChanged('final') ? 'red' : 'black';
                                const colorCorrida = isChanged('corrida') ? 'red' : 'black';

                                return [
                                    ...(hasMultipleStations ? [{ text: item.nombreEstacion, fontSize: 8 }] : []),
                                    { text: item.manguera, fontSize: 9 },
                                    { text: item.tipocombustible, fontSize: 9 },
                                    { text: `$ ${parseFloat(precio).toLocaleString('es-AR', { minimumFractionDigits: 3 })}`, fontSize: 9, alignment: 'right' },
                                    { text: parseFloat(item.inicial).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', color: colorInicial },
                                    { text: parseFloat(pruebaRet).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', color: !isGNC ? colorCorrida : 'black' },
                                    { text: parseFloat(pruebaSRet).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', color: isGNC ? colorCorrida : 'black' },
                                    { text: parseFloat(item.final).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', color: colorFinal },
                                    { text: litrosDif.toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right' },
                                    { text: `$ ${diferenciaPesos.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' }
                                ];
                            }),
                            // Total Row
                            [
                                { text: "TOTALES", bold: true, fontSize: 9, colSpan: hasMultipleStations ? 4 : 3, alignment: 'right' },
                                ...(hasMultipleStations ? [{}] : []),
                                {}, {},
                                { text: allAforadores.reduce((acc, item) => acc + parseFloat(item.inicial || 0), 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true },
                                {
                                    text: allAforadores.reduce((acc, item) => {
                                        const isGNC = item.tipocombustible === 'GNC';
                                        return acc + (isGNC ? 0 : parseFloat(item.corrida || 0));
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true
                                },
                                {
                                    text: allAforadores.reduce((acc, item) => {
                                        const isGNC = item.tipocombustible === 'GNC';
                                        return acc + (isGNC ? parseFloat(item.corrida || 0) : 0);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true
                                },
                                { text: allAforadores.reduce((acc, item) => acc + parseFloat(item.final || 0), 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true },
                                {
                                    text: allAforadores.reduce((acc, item) => {
                                        const diferencia = item.final - item.inicial;
                                        const corrida = parseFloat(item.corrida || 0);
                                        return acc + (diferencia - corrida);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true
                                },
                                {
                                    text: `$ ${allAforadores.reduce((acc, item) => {
                                        const diferencia = item.final - item.inicial;
                                        const precios = parseJsonSafe(item.precios);
                                        const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                        const precio = precioObj ? precioObj.precio : 0;
                                        const corrida = parseFloat(item.corrida || 0);
                                        return acc + ((diferencia - corrida) * precio);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right', bold: true
                                }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: function (i, node) { return (i === 0 || i === node.table.body.length || i === 2 || i === node.table.body.length - 1) ? 1 : 0; },
                        vLineWidth: function (i, node) { return 0; },
                        hLineColor: function (i, node) { return (i === 0 || i === node.table.body.length) ? 'black' : 'gray'; },
                    }
                },
                { text: "\n" },
                {
                    width: "100%",
                    text: "VENTAS POR PRODUCTO",
                    fontSize: 12,
                    bold: true,
                    margin: [0, 5, 0, 5],
                    alignment: "center"
                },
                {
                    table: {
                        headerRows: 1,
                        widths: ["*", "*", "*", "*", "*", "*", "*"],
                        body: [
                            [
                                { text: "COMBUSTIBLE", bold: true, fontSize: 9 },
                                { text: "LTS. VENTA", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "IMP. VENTA", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "LTS. FACT.", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "IMP. FACT.", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "LTS. DIF.", bold: true, fontSize: 9, alignment: 'right' },
                                { text: "PESOS DIF.", bold: true, fontSize: 9, alignment: 'right' }
                            ],
                            ...Object.values(allAforadores.reduce((acc, item) => {
                                const combustible = item.tipocombustible;
                                if (!acc[combustible]) {
                                    acc[combustible] = {
                                        nombre: combustible,
                                        ltsVenta: 0,
                                        impVenta: 0,
                                        ltsFact: 0,
                                        impFact: 0
                                    };
                                }
                                const diferencia = item.final - item.inicial;
                                const precios = parseJsonSafe(item.precios);
                                const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                const precio = precioObj ? precioObj.precio : 0;
                                const corrida = parseFloat(item.corrida || 0);
                                const litrosDif = diferencia - corrida;
                                const diferenciaPesos = litrosDif * precio;

                                acc[combustible].ltsVenta += litrosDif;
                                acc[combustible].impVenta += diferenciaPesos;
                                return acc;
                            }, {})).map(prod => {
                                const ltsDif = prod.ltsVenta - prod.ltsFact;
                                const pesosDif = prod.impVenta - prod.impFact;
                                return [
                                    { text: prod.nombre, fontSize: 9 },
                                    { text: prod.ltsVenta.toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right' },
                                    { text: `$ ${prod.impVenta.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' },
                                    { text: prod.ltsFact.toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right' },
                                    { text: `$ ${prod.impFact.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' },
                                    { text: ltsDif.toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right' },
                                    { text: `$ ${pesosDif.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right' }
                                ];
                            }),
                            // Total Row for Sales
                            [
                                { text: "TOTALES", bold: true, fontSize: 9 },
                                {
                                    text: allAforadores.reduce((acc, item) => {
                                        const diferencia = item.final - item.inicial;
                                        const corrida = parseFloat(item.corrida || 0);
                                        return acc + (diferencia - corrida);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true, border: [false, true, false, false]
                                },
                                {
                                    text: `$ ${allAforadores.reduce((acc, item) => {
                                        const diferencia = item.final - item.inicial;
                                        const precios = parseJsonSafe(item.precios);
                                        const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                        const precio = precioObj ? precioObj.precio : 0;
                                        const corrida = parseFloat(item.corrida || 0);
                                        return acc + ((diferencia - corrida) * precio);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right', bold: true, border: [false, true, false, false]
                                },
                                { text: "0,00", fontSize: 9, alignment: 'right', bold: true, border: [false, true, false, false] },
                                { text: "$ 0,00", fontSize: 9, alignment: 'right', bold: true, border: [false, true, false, false] },
                                {
                                    text: allAforadores.reduce((acc, item) => {
                                        const diferencia = item.final - item.inicial;
                                        const corrida = parseFloat(item.corrida || 0);
                                        return acc + (diferencia - corrida);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 }), fontSize: 9, alignment: 'right', bold: true, border: [false, true, false, false]
                                },
                                {
                                    text: `$ ${allAforadores.reduce((acc, item) => {
                                        const diferencia = item.final - item.inicial;
                                        const precios = parseJsonSafe(item.precios);
                                        const precioObj = precios.find(p => p.nombre === item.tipocombustible);
                                        const precio = precioObj ? precioObj.precio : 0;
                                        const corrida = parseFloat(item.corrida || 0);
                                        return acc + ((diferencia - corrida) * precio);
                                    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`, fontSize: 9, alignment: 'right', bold: true, border: [false, true, false, false]
                                }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: function (i, node) { return (i === 0 || i === node.table.body.length || i === 2 || i === node.table.body.length - 1) ? 1 : 0; },
                        vLineWidth: function (i, node) { return 0; },
                        hLineColor: function (i, node) { return (i === 0 || i === node.table.body.length) ? 'black' : 'gray'; },
                    }
                },
                ...(() => {
                    const allModificaciones = data.flatMap(cierre => {
                        const mods = parseJsonSafe(cierre.modificaciones);
                        return Array.isArray(mods) ? mods.map(m => ({ ...m, nombreEstacion: cierre.nombreEstacion })) : [];
                    });

                    if (allModificaciones.length === 0) return [];

                    return [
                        { text: "\n" },
                        {
                            width: "100%",
                            text: "HISTORIAL DE MODIFICACIONES",
                            fontSize: 12,
                            bold: true,
                            margin: [0, 5, 0, 5],
                            alignment: "center"
                        },
                        {
                            table: {
                                widths: hasMultipleStations ? ["auto", "auto", "auto", "auto", "*"] : ["auto", "auto", "auto", "*"],
                                body: [
                                    [
                                        ...(hasMultipleStations ? [{ text: "ESTACION", bold: true, fontSize: 9 }] : []),
                                        { text: "FECHA", bold: true, fontSize: 9 },
                                        { text: "USUARIO", bold: true, fontSize: 9 },
                                        { text: "MOTIVO", bold: true, fontSize: 9 },
                                        { text: "DETALLE", bold: true, fontSize: 9 }
                                    ],
                                    ...allModificaciones.map(mod => {
                                        let detalles = [];
                                        if (mod.cambios) {
                                            Object.keys(mod.cambios).forEach(key => {
                                                const cambio = mod.cambios[key];
                                                if (key === 'importetarjetas') {
                                                    detalles.push(`Tarjetas: $${cambio.anterior} -> $${cambio.nuevo}`);
                                                } else if (key === 'fondofijo') {
                                                    detalles.push(`Fondo Fijo: $${cambio.anterior} -> $${cambio.nuevo}`);
                                                } else if (key === 'promociones') {
                                                    const ant = cambio.anterior || {};
                                                    const nue = cambio.nuevo || {};
                                                    if (ant.promociones?.monto != nue.promociones?.monto) detalles.push(`Promo: $${ant.promociones?.monto} -> $${nue.promociones?.monto}`);
                                                    if (ant.ventaanticipada?.monto != nue.ventaanticipada?.monto) detalles.push(`V.Ant: $${ant.ventaanticipada?.monto} -> $${nue.ventaanticipada?.monto}`);
                                                    if (ant.bonificacion?.monto != nue.bonificacion?.monto) detalles.push(`Bonif: $${ant.bonificacion?.monto} -> $${nue.bonificacion?.monto}`);
                                                } else if (key === 'aforadoresauto' || key === 'aforadoresmanual') {
                                                    const tipo = key === 'aforadoresauto' ? 'Auto' : 'Manual';
                                                    const antArr = cambio.anterior || [];
                                                    const nueArr = cambio.nuevo || [];

                                                    nueArr.forEach(nueItem => {
                                                        const antItem = antArr.find(a => a.manguera == nueItem.manguera && a.tipocombustible == nueItem.tipocombustible);
                                                        if (antItem) {
                                                            if (antItem.inicial != nueItem.inicial) detalles.push(`${tipo} M${nueItem.manguera} ${nueItem.tipocombustible} Ini: ${antItem.inicial} -> ${nueItem.inicial}`);
                                                            if (antItem.final != nueItem.final) detalles.push(`${tipo} M${nueItem.manguera} ${nueItem.tipocombustible} Fin: ${antItem.final} -> ${nueItem.final}`);
                                                            if (antItem.corrida != nueItem.corrida) detalles.push(`${tipo} M${nueItem.manguera} ${nueItem.tipocombustible} Corr: ${antItem.corrida} -> ${nueItem.corrida}`);
                                                        } else {
                                                            detalles.push(`${tipo} M${nueItem.manguera} Nuevo`);
                                                        }
                                                    });
                                                } else {
                                                    detalles.push(`${key}: ${cambio.anterior} -> ${cambio.nuevo}`);
                                                }
                                            });
                                        }
                                        return [
                                            ...(hasMultipleStations ? [{ text: mod.nombreEstacion, fontSize: 8 }] : []),
                                            { text: new Date(mod.fecha).toLocaleString(), fontSize: 9 },
                                            { text: mod.usuario_nombre || 'Desconocido', fontSize: 9 },
                                            { text: mod.motivo || '-', fontSize: 9 },
                                            { text: detalles.join('\n'), fontSize: 8 }
                                        ];
                                    })
                                ]
                            },
                            layout: "lightHorizontalLines"
                        }
                    ];
                })()
            ]
        };

        pdfMake.createPdf(docDefinition).open();
    };


    return ({
        ReporteStock,
        ReporteTransacciones,
        ReporteListaCierres,
        ReporteCierreIndividual
    }
    )
};

export default GenerarPdf;
